import { Component, OnInit, ViewChild, TemplateRef, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../Master/user/user.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DialogService } from 'ng2-bootstrap-modal';
import { DatePipe } from '@angular/common';
import { cbadashboardService } from './cbadashboard.service';
import { saveFile, saveAs } from 'file-saver';	
import { LocalService } from '../../local.service';	
import { environment } from '../../../environments/environment';	
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
//import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import * as Papa from 'papaparse';
import * as XLSX from 'xlsx';
//import { ClipboardService } from 'ngx-clipboard';
									   
declare var $: any;


@Component({
  selector: 'app-cbadashboard',
  templateUrl: './cbadashboard.component.html',
  styleUrls: ['./cbadashboard.component.css']
})
export class CbadashboardComponent implements OnInit {
  list: any;

  headers: any;
 
  p: number = 1;
  userid: number = 0; 
  sortDirection: string = 'desc'; colkey: string = ''; 
  pageevent: boolean = false;
 
  sortingcondition: string = '';  
	paginationLimit:Number=5;   		  
  rows: string[];  
  rowsData: any = [];  
  isSort: boolean = false;
  fromlaat:number=0;
  fromuser:number=0;
batchcount:number=0;
pagenumber:number=1;
pendingFileDtsRef: BsModalRef;	
config: ModalOptions = {
  backdrop: 'static',
  keyboard: false,
  animated: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered modal-customlarge'
};
pendingFileLst:any=[];
docHeaders: any=[];
pendingFileCnt=0;
p_pendingFileCnt=1;
itemsPerPage: number = 10;
itemsPerPageBatch=10;
selectedBatchId:number=0;
uploadCSVItem:any;
csvRecords: any;
  csvheader: boolean = false; _rowsData: any = []; _itemsPerPageBatch=10;_batchcount:number=0;
  _pagenumber:number=1; _headers: any;
  constructor(private _router: Router, private _cbadashboardService: cbadashboardService,
    private toastr: ToastrService, private userservice: UserService, private SpinnerService: NgxSpinnerService,
     private dialogService: DialogService,     
    private datePipe: DatePipe,private localService: LocalService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef
  ) {


  }

  ngOnInit() {
    this.getnewreccount();
    this. getAll();
   }
    copyText(text) {
    navigator.clipboard.writeText(text);
  }
   copyInputMessage(inputElement){
     debugger
    let element = $('#'+inputElement).val();//document.getElementById(inputElement); //select the element
    let elementText = element;//.textContent; //get the text content from the element
    this.copyText(elementText);
    this.toastr.success('Link text copied successfully');
  }
   OpenPendingFileDts(template: TemplateRef<any>,item){
     debugger
    this.pendingFileDtsRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove('modal-content');
     this.getBatchPendingFiles(item);
    //this.getRequestDetails_SearchAll('allrequests', 0)
   }
   changeitemsperpagebatch(eve){
    this.itemsPerPageBatch = +eve.currentTarget.value;
    this.pagenumber=1;
    this.getAll();
   }
   _changeitemsperpagebatch(eve){
    this._itemsPerPageBatch = +eve.currentTarget.value;
    this._pagenumber=1;
    this.getAllCompleted();
   }
   getPendingLst(page: number){
this.p_pendingFileCnt=page;
var inp=[];
inp.push({cbabatchid:this.selectedBatchId});
this.getBatchPendingFiles(inp[0]);
   }

   getPageBatch(page: number){
     this.pagenumber=page;
     this.getAll();

   }
   _getPageBatch(page: number){
    this._pagenumber=page;
    this.getAllCompleted();

  }
   getAllCompleted(){
    this.SpinnerService.show();
    this._cbadashboardService.getAllBatchCount(this.itemsPerPageBatch,this.pagenumber,'getallcompletedbatchcount').subscribe(result => {
     if(result!=undefined && result!=null){
       debugger
      let cnt =JSON.parse(result[0]);
      this._batchcount=cnt[0].count;
      if(this._batchcount>0){
        this._cbadashboardService.getAllBatch(this.itemsPerPageBatch,this.pagenumber,'getallcompletedbatch').subscribe(res => {
          debugger
         // console.log(res[0]);
          let data =JSON.parse(res[0]);
          if(data.length >0){
            //this.batchcount=data.length;
            this._headers=[];
            var _headers = Object.keys(data[0]);
            this._headers=_headers;
          //  console.log(this.headers);
            this._rowsData=[];
            this._rowsData=data;
            console.log( this._rowsData);
            this.SpinnerService.hide();
          }
    
        },err=>{
          this.SpinnerService.hide();
          console.log(err);
        }); 
      }else{
        this._rowsData=[];
        this._headers=[];
        this.SpinnerService.hide();

      }
     }
    },err=>{
      this.SpinnerService.hide();
      console.log(err);
    });
    
   }
   getAll(){
    this.SpinnerService.show();
    this._cbadashboardService.getAllBatchCount(this.itemsPerPageBatch,this.pagenumber,'getallbatchcount').subscribe(result => {
     if(result!=undefined && result!=null){
       debugger
      let cnt =JSON.parse(result[0]);
      this.batchcount=cnt[0].count;
      debugger
      if(this.batchcount>0){
        this._cbadashboardService.getAllBatch(this.itemsPerPageBatch,this.pagenumber,'getallbatch').subscribe(res => {
          debugger
         // console.log(res[0]);
          let data =JSON.parse(res[0]);
          if(data.length >0){
            //this.batchcount=data.length;
            this.headers=[];
            var _headers = Object.keys(data[0]);
            this.headers=_headers;
          //  console.log(this.headers);
            this.rowsData=[];
            this.rowsData=data;
            this.SpinnerService.hide();
          }
    
        },err=>{
          this.SpinnerService.hide();
          console.log(err);
        }); 
      }
     }else{
      this.rowsData=[];
      this.headers=[];
      this.SpinnerService.hide();
     }
    },err=>{
      this.SpinnerService.hide();
      console.log(err);
    });
    
   
    
    
   }

   getnewreccount(){
    this._cbadashboardService.getnewreccount().subscribe(res => {
      console.log(res);
      if(res!=undefined && res!=null){
        this.fromlaat = res.fromlaat;
        this.fromuser=res.fromuser;
      }
    });
   }
   createBatch(){
    var input = [];
    this.SpinnerService.show();
    input.push(
      {
        'userid': +this.localService.getJsonValue('userid')      
      })
    this._cbadashboardService.batchcreation(input[0]).subscribe(res => {
      console.log(res);
      if(res.body!=undefined && res.body!=null&&res.body.Batch_ID>0){//res.body.Batch_ID
      this.SpinnerService.hide();
      this.toastr.success('Records imported and batch created successfully');
      this.getnewreccount();
      this. getAll();
      }
    },err=>{
      console.log(err);
      this.SpinnerService.hide();
      this.toastr.error(err);
    });
   }

   changeitemsperpage(eve){
    this.itemsPerPage = +eve.currentTarget.value;
    this.p_pendingFileCnt=1;
    var inp=[];
    inp.push({cbabatchid:this.selectedBatchId});
    this.getBatchPendingFiles(inp[0]);
   }

  getBatchPendingFiles(item){
    debugger
this.SpinnerService.show();
   this.selectedBatchId=item.cbabatchid;
   this._cbadashboardService.getBatchPendingFilescount(item.cbabatchid,this.itemsPerPage,this.p_pendingFileCnt).subscribe(result=>{
    if(result!=undefined && result!=null){
      debugger
     let cnt =JSON.parse(result[0]);
     this.pendingFileCnt=cnt[0].count;
     this._cbadashboardService.getBatchPendingFiles(item.cbabatchid,this.itemsPerPage,this.p_pendingFileCnt).subscribe(res => {
      debugger
      console.log(res[0]);
      let data =JSON.parse(res[0]);
      if(data.length >0){
       // this.pendingFileCnt=data.length;
        console.log( this.pendingFileCnt);
        this.docHeaders=[];
        var _headers = Object.keys(data[0]);
        this.docHeaders=_headers;
        console.log(this.headers);
        this.pendingFileLst=[];
        this.pendingFileLst=data;
        this.SpinnerService.hide();
      }
    
    },err=>{
      this.SpinnerService.hide();
      console.log(err);
    });
    }
   })
 


  }
  pendingFileDtsClose(){
   this. itemsPerPage=10;
    this.pendingFileDtsRef.hide();
  }

  downloadUploadedZipFile(item){
    let filedownloadUrl: string = environment.appUrl;
    console.log(item);
  var newWindow = window.open(filedownloadUrl + 'filedownload?dbname=' + item.dbname + '&mode=' + 'batchfile&formconfigid=' 
    + item.formconfigid + '&link='+item["SFTP Link"]);
  }

  uploadCSVFile(item){
    console.log(item);
    this.uploadCSVItem=item;
    console.log($('#file-input'));
  }
  downloadxmlpdfFile(item){
  let input=[];
  input.push({
    batchid:+item.cbabatchid,
    userid:+this.localService.getJsonValue("userid"),
    dbname:item.dbname,
    formconfigid:+item.formconfigid,
    batchName:item["Batch Name"]
  });
this._cbadashboardService.uploadXMLToSFTP(input[0]).subscribe(res=>{
if(res.body!=null && res.body !=undefined){
this.toastr.success('XML and PDF files are started moving to the SFTP path....');
}
},err=>{
  this.toastr.error('Please check exception email for more details...');
 // this.toastr.error(err);
})
  }
  fileupload(eve){
    debugger
    this.SpinnerService.show();
    let item=this.uploadCSVItem;
    this.userid = +this.localService.getJsonValue("userid");
    console.log(eve);
    console.log($('#file-input'));
    console.log(item);
    var file: File = eve.target.files[0];
    console.log(file);
    var extension = file.name.split('.').pop();
    console.log(extension);
    if(extension == 'xlsx'){
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(eve.target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws, {defval: ''}); // to get 2d array pass 2nd parameter as object {header: 1}
      console.log(data); // Data will be logged in array format containing objects
      this.csvRecords = data;
      debugger
      var rec =  this.csvRecords.filter(m=>m.Selected.toString()=='');
      if(rec.length>0){
        this.SpinnerService.hide();
          this.toastr.error('Uploaded xlsx is not valid,selected should not be empty');
          $('#file-input').val('');
      }
      else{
        var xmldetails = this.csvRecords.filter(m=>m.Selected.toString().toLowerCase()=='true');
        let _notvalid=xmldetails.filter(x=>x.XML_content.toString()=='' || x.XML_Filename.toString()=='' );
        if(_notvalid.length>0){
          this.SpinnerService.hide();
          this.toastr.error('Uploaded xlsx is not valid,XML content and XML filename should not be empty');
          $('#file-input').val('');
        }
        else{
         // this.SpinnerService.show();
          this._cbadashboardService.getpendinglistacrnbybatchid(item.cbabatchid).subscribe(result=>{
            if(result!=undefined && result!=null){
              debugger
            // let cnt =JSON.parse(result[0]);
             var ids=result[0].id
             if (ids!=undefined && ids!=null){
               let id_arr=ids.split(',');
               if (id_arr.length>0){
              let id_csv=  this.csvRecords.map(x=>x.ACRN_ID.toString())
              var isPresent = id_csv.every(function(val) {
                return id_arr.indexOf(val) >= 0;
              })
            //  if (id_csv.sort().join('|') === id_arr.sort().join('|')) {
               // console.log('The arrays are equal.');
             if(isPresent==true)   {   
          const formData = new FormData();
          formData.set('file',file);
          formData.set('userid',this.userid.toString());
          formData.set('batchid',item.cbabatchid.toString());
          formData.set('dbname',item.dbname.toString());
          formData.set('formconfigid',item.formconfigid.toString());
         this._cbadashboardService.UploadCSVFile(formData).subscribe(res=>{
        console.log(res);
        this.SpinnerService.hide();
        this.toastr.success('XLSX file uploaded successfully, creating XML file is in process');
        $('#file-input').val('');
        },err=>{
          
        this.SpinnerService.hide();
          this.toastr.error('Please check the date format is valid,for more details check exception email');
          $('#file-input').val('');
        })
            } else {
              this.toastr.error('The uploaded XLSX file is not a valid one for this batch');
              this.SpinnerService.hide();
              $('#file-input').val('');
            }
                 console.log(this.csvRecords);
               }
             }
            }    
        
          },err=>{
            this.SpinnerService.hide();
            debugger
            this.toastr.error(err);
            console.log(err);
          });
        
        }
      }
      
    };
  /*  Papa.parse(eve.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: (result,file) => {
        console.log(result);
        this.csvRecords = result.data;
      var rec =  this.csvRecords.filter(m=>m.Selected=='');
      if(rec.length>0){
        this.SpinnerService.hide();
          this.toastr.error('Uploaded xlsx is not valid,selected should not be empty');
          $('#file-input').val('');
      }
      else{
        var xmldetails = this.csvRecords.filter(m=>m.Selected=='TRUE');
        let _notvalid=xmldetails.filter(x=>x.XML_content=='' || x.XML_Filename=='' );
        if(_notvalid.length>0){
          this.SpinnerService.hide();
          this.toastr.error('Uploaded xlsx is not valid,XML content and XML filename should not be empty');
          $('#file-input').val('');
        }
        else{
         // this.SpinnerService.show();
          this._cbadashboardService.getpendinglistacrnbybatchid(item.cbabatchid).subscribe(result=>{
            if(result!=undefined && result!=null){
              debugger
            // let cnt =JSON.parse(result[0]);
             var ids=result[0].id
             if (ids!=undefined && ids!=null){
               let id_arr=ids.split(',');
               if (id_arr.length>0){
              let id_csv=  this.csvRecords.map(x=>x.ACRN_ID)
              var isPresent = id_csv.every(function(val) {
                return id_arr.indexOf(val) >= 0;
              })
            //  if (id_csv.sort().join('|') === id_arr.sort().join('|')) {
               // console.log('The arrays are equal.');
             if(isPresent==true)   {   
          const formData = new FormData();
          formData.set('file',file);
          formData.set('userid',this.userid.toString());
          formData.set('batchid',item.cbabatchid.toString());
          formData.set('dbname',item.dbname.toString());
          formData.set('formconfigid',item.formconfigid.toString());
         this._cbadashboardService.UploadCSVFile(formData).subscribe(res=>{
        console.log(res);
        this.SpinnerService.hide();
        this.toastr.success('XLSX file uploaded successfully, creating XML file is in process');
        $('#file-input').val('');
        },err=>{
        this.SpinnerService.hide();
         // this.toastr.error(err);
         this.toastr.error('Please check the date format is valid,for more details check exception email');
          $('#file-input').val('');
        })
            } else {
              this.toastr.error('The uploaded XLSX file is not a valid one for this batch');
              this.SpinnerService.hide();
              $('#file-input').val('');
            }
                 console.log(this.csvRecords);
               }
             }
            }    
        
          },err=>{
            this.SpinnerService.hide();
            this.toastr.error(err);
            console.log(err);
          });
        
        }
      }
      }
    });*/
  }
  else{
    this.SpinnerService.hide();
    this.toastr.error('Upload to only xlsx file');
    $('#file-input').val('');
  }
   
    
  }

  downloadxmlpdfFilefromACRN(item){
    let filedownloadUrl: string = environment.appUrl;
    console.log(item);
  var newWindow = window.open(filedownloadUrl + 'filedownload?dbname=' + item.dbname + '&mode=' + 'batchfileFinal&formconfigid=' 
    + item.formconfigid + '&link='+item["SFTP Link"]);
  }
  batchCompletion(item){
    let input=[];
    this.SpinnerService.show();
  input.push({
    batchid:+item.cbabatchid,
    userid:+this.localService.getJsonValue("userid")    
  });
  this._cbadashboardService.batchCompletion(input[0]).subscribe(res=>{
    console.log(res);
    if(res.body!=null && res.body !=undefined){
      this.SpinnerService.hide();
    this.toastr.success('Batch completed successfully');
    this.getAll();
    }
    },err=>{
      this.toastr.error(err);
      this.SpinnerService.hide();
    })
  }

  refreshPage(){
    window.location.reload();
  }
 


  
}
